var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"typeD-btn white--text",attrs:{"color":"primary","fab":"","small":"","elevation":"0"},on:{"click":_vm.emitClick}},[_c('v-icon',{staticClass:"text-2"},[_vm._v("ri-add-line")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }